import { MeasurementResDto } from "service/api/estabrookSchemas";

/**
 * Zero snow measurement, mirroring what the backend returns for a location with
 * no accumulated snow (`createDistanceObject({ distance: 0, unit: INCH })`).
 *
 * Used to fill the required `snowAmount` on locally-constructed placeholder
 * route locations (the "Unassigned" route, region management mock rows), which
 * have no real snow data.
 */
export const ZERO_SNOW_AMOUNT: MeasurementResDto = {
  imperial: { value: 0, type: "distance", symbol: '"' },
  metric: { value: 0, type: "distance", symbol: "mm" },
};
